import axios from 'axios';
import {Actualizar_datos, encriptado, Procesar, Tasa_cambio, Usuario, Ver_Valores} from '../constantes';
import { uploadImagen } from './api_cloundinary';

let User; 
let Api;
const Inicio = async(user)=>{
  User= user===null ? {username:'Anonimo'} : user;
}

export const conexiones = {
  Sincronizar,
  Ver_api,
  Login,
  Inicio,
  Enviar,
  Leer,
  Leer_C,
  Guardar,
  Guardar_Pago,
  Eliminar,
  Leer_data,
  Guardar_data,
  Eliminar_data,
  DataBase,
  VerApis,
  Verificar,
  Guardar_excel,
  ValorCambio,
  Mensualidades,
  Solvencias,
  Notas,
  NNotas,
  NTitulos,
  Resumen,
  Inscritos,
  Recibo,
  Enviar_pago,
  Sincronizar_uecla,
  Actualizar_Referencia,
  VerInscripcion_uecla,
  Promover,
  NominaDocente,
  WhatsappEnviar,
  // //SistemaCHS
  // Guardar_produccion,
  // Ingresar,
  // Ingresar_material,
  // Ingresar_empaque,
  // Ingreso_Egreso,
  // Recibo_Venta,
  // Egreso_venta,
  // Ventas,
  Serial,
  // MisDatos,
  LeerHorario,
  GuardarHorario,
  DisponibilidadHorario,
  WhatsappQR
}

async function Sincronizar(tablas, datos, timeout=50000,mensaje='Solicitando datos...'){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{tablas, datos, Api},
                            http_destino:'/api/sincronizar',
                            method:'POST',
                            timeout,
                            mensaje_esperar:mensaje
                          });
  return resultados
}
//Ver codigo de api
async function Ver_api(api){
  const resultados= await Enviar({
    datos:{api},
    http_destino:'/api/ver_api',
    method:'POST',
  });
  
  if (resultados.Respuesta==='Ok'){
    Api= resultados.api;
    return Api
  }else{
    // confirmAlert({
    //   title: 'Problemas en conexión con servidor',
    //   buttons: [
    //     {label: 'Continuar'},
    //     {label: 'Reintentar', onClick: ()=>window.location.reload()}
    //   ]
    // });
  }
  // else if (resultados.Respuesta==='Ok'){
  //   return resultados.api;
  // }
  return {}
}
//Login
async function Login(datos, api){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
    datos:{...datos, Api, mantener:true, crear: false},
    http_destino:'/api/login',
  });
  return resultados
}
//Leer datos de archivo
async function Leer_data(archivo, api, valord={}){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User, Api, archivo, valord},
                            http_destino:'/api/leer_data',
                            method:'POST',
                          });
  return resultados
}
//Guardar archivo
async function Guardar_data(archivo, valor){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User, Api, archivo, valor},
                            http_destino:'/api/guardar_data',
                            method:'POST',
                          });
  return resultados
}
//Elimina archivo
async function Eliminar_data(archivo){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User, Api, archivo},
                            http_destino:'/api/eliminar_data',
                            method:'DELETE',
                          });
  return resultados
}
//Ver bases de datos del sistema
async function DataBase(){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User, Api},
                            http_destino:'/api/database',
                            method:'POST',
                          });
  return resultados
}
//Ver bases de datos del sistema
async function VerApis(){
  const resultados= await Enviar({
                            datos:{User},
                            http_destino:'/api/verapis',
                            method:'POST',
                          });
  return resultados
}
//Pide datos al servidor
//Necesario tablas=[tabla1,tabla2....]
async function Leer(tablas, mensaje='Solicitando datos...'){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User,tablas, Api},
                            http_destino:'/api/getall',
                            method:'POST',
                            mensaje_esperar:mensaje
                          });
  return resultados
}
async function Leer_C(tablas, condicion, api= Ver_Valores().valores.app, timeout=100000,mensaje='Solicitando datos...'){
  const Api = api;
  tablas=Object.keys(condicion)
  const resultados= await Enviar({
                            datos:{User,tablas, condicion, Api},
                            http_destino:'/api/getallc',
                            method:'POST',
                            timeout,
                            mensaje_esperar:mensaje
                          });
  return resultados
}
//Guardar Datos
async function Guardar(dato, tabla, api= Ver_Valores().valores.app, user=undefined, mensaje='Guardando datos...', acciones=null){
  dato.actualizado=user ? user : User ? User.username : 'Sin usuario';
  let files=undefined;
  let imagenes= ['foto','avatar','image-cedula', 'video', 'logo', 'Logo', 'img', 'portada'];
  if (dato.files && Object.keys(dato.files).length!==0){
    files=dato.files;
  }else if (dato.file){
    files={'file_0':dato.file[0]};
    // dato.file=null;
  } else if (dato.multiples_valores){
    // console.log('Por aquiiiiiiii', dato.valores)
    if (dato.valores.password && dato.valores.passwordc
        && dato.valores.password===dato.valores.passwordc
        &&dato.valores.password!==''
        ){
          dato.valores.newpassword = dato.valores.password;
          delete dato.valores.password;
          delete dato.valores.passwordc;
        }
    if (dato.valores._id) dato['_id']=dato.valores._id
    Object.keys(dato.valores).map(val=>{
      const nombre=val.split('_url')[0];
      
      if (val.indexOf('_url')!==-1 && dato.valores[nombre]){ 
          if (files===undefined) files={}
          files={...files, [nombre]:dato.valores[nombre][0]}
          delete dato.valores[val]
      }else if(val.indexOf('Error-')!==-1){
        delete dato.valores[val]
      }

      return val
    })
  }else{
    imagenes.map(val=>{
      if (Object.keys(dato).indexOf(val)!==-1 && dato[val]!==undefined){
        if (files===undefined) files={}

        files={...files, [val]:dato[val][0]}
      }
      return val
    })
  }
  const {cloud_name, carpeta} = Ver_Valores().valores;
  // console.log('>>>>>>>archivos',files, cloud_name, carpeta)
  if (files){
    for (var i=0 ; i<Object.keys(files).length; i++){
      const camp = Object.keys(files)[i];
      let res = await uploadImagen(files[camp], carpeta, cloud_name);
      if (res===null && dato.multiples_valores){
        delete dato.valores[camp];
      }else if (res===null){
        delete dato[camp];
      }else if (dato.multiples_valores){
        dato.valores[camp]= res;
      }else{
        dato[camp]= res;
      }

    }
    
    files=undefined;
  }
  const Api = api;
  // const usuario = user ? user : User ? User : 
  const resultados= await Enviar({
                            datos:{User: user ? user : User ? User : {username:'Anonimo'} , Api, datos:JSON.stringify(dato), tabla},
                            http_destino:'/api/setall',
                            method:'POST',
                            destino:'imagenes',
                            mensaje_esperar:mensaje,
                            tipo:files!==undefined ? 'Archivos' : false,
                            files,
                            acciones
                          });
  return resultados
}
//eliminar
async function Eliminar(dato, tablas, mensaje='Eliminar datos...'){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{dato:{...dato, user:User.username }, Api, tablas},
                            http_destino:'/api/delall',
                            method:'DELETE',
                            mensaje_esperar:mensaje
                          });
  return resultados
}

//eliminar
async function Verificar(dato){
  
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{...dato, Api},
                            http_destino:'/api/login/verificar',
                            method:'POST',
                          });
  return resultados
}

//Guardar excel
async function Guardar_excel(valores){
  const resultados= await Enviar({
                            datos:{User, valores},
                            http_destino:'/api/guardar_excel',
                            method:'POST',
                          });
  return resultados
}
//Colegio
//Ver tasa de cambio
async function ValorCambio(){
  let resultados= await Enviar({
                            datos:{User},
                            http_destino:'/api/valor_dolar',
                            method:'POST',
                          });
  
  if (resultados.Respuesta==='Ok'){
    await Tasa_cambio({status:'Guardar', dato:{tasa:resultados.valor}})
  }else{
    resultados.Respuesta='Ok';
    resultados.valor= await Tasa_cambio({});
  }
  
  return resultados
}
//Solicitar Mensualidades
async function Mensualidades(dato, mensaje='Guardando datos...'){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User, Api, datos:JSON.stringify(dato)},
                            http_destino:'/api/colegio/mensualidades',
                            method:'POST',
                            destino:'archivos/imagenes',
                            mensaje_esperar:mensaje,
                          });                    
  return resultados
}
//Solicitar Solvencias
async function Solvencias(dato, mensaje='Guardando datos...'){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User, Api, datos:JSON.stringify(dato)},
                            http_destino:'/api/colegio/solvencias',
                            method:'POST',
                            destino:'archivos/imagenes',
                            mensaje_esperar:mensaje,
                          });
  return resultados
}
//Solicitar Notas
async function Notas(dato, mensaje='Guardando datos...'){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User, Api, datos:JSON.stringify(dato)},
                            http_destino:'/api/colegio/notas',
                            method:'POST',
                            destino:'archivos/imagenes',
                            mensaje_esperar:mensaje,
                          });
  return resultados
}
//Solicitar Notas
async function NNotas(dato, mensaje='Guardando datos...'){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User, Api, datos:JSON.stringify(dato)},
                            http_destino:'/api/colegio/nnotas',
                            method:'POST',
                            destino:'archivos/imagenes',
                            mensaje_esperar:mensaje,
                          });
  return resultados
}
//Solicitar titulos de  notas en asignaturas
async function NTitulos(dato, mensaje='Guardando datos...'){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User, Api, datos:JSON.stringify(dato)},
                            http_destino:'/api/colegio/ntitulos',
                            method:'POST',
                            destino:'archivos/imagenes',
                            mensaje_esperar:mensaje,
                          });
  return resultados
}
//Resumen
async function Resumen(dato, mensaje='Guardando datos...'){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User, Api, datos:JSON.stringify(dato)},
                            http_destino:'/api/colegio/resumen',
                            method:'POST',
                            destino:'archivos/imagenes',
                            mensaje_esperar:mensaje,
                          });
  return resultados
}
//Inscritos
async function Inscritos(dato, mensaje='Guardando datos...'){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User, Api, datos:JSON.stringify(dato)},
                            http_destino:'/api/colegio/inscritos',
                            method:'POST',
                            destino:'archivos/imagenes',
                            timeout:250000,
                            mensaje_esperar:mensaje,
                          });
  return resultados
}
//Recibo
async function Recibo(dato, mensaje='Guardando datos...'){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User, Api, datos:JSON.stringify(dato)},
                            http_destino:'/api/colegio/recibo',
                            method:'POST',
                            destino:'archivos/imagenes',
                            mensaje_esperar:mensaje,
                          });
  return resultados
}
//Enviar Pago
async function Enviar_pago(dato, mensaje='Guardando datos...'){
  const Api = Ver_Valores().valores.app;
  console.log(dato)
  const {cloud_name, carpeta} = Ver_Valores().valores;
  console.log('>>>>>>>archivos',dato.files, cloud_name, carpeta);
  if (dato.files && dato.files.length!==0){
    let nuevo = [];
    for (var i=0 ; i<dato.files.length; i++){
      let res = await uploadImagen(dato.files[i], carpeta, cloud_name);
      if (res!==null){
        nuevo=[...nuevo, res]; 
      }
    }
    dato.files = nuevo;
  }
  const resultados= await Enviar({
                            datos:{User, Api, datos:JSON.stringify(dato)},
                            http_destino:'/api/colegio/enviarpago',
                            method:'POST',
                            destino:'archivos/imagenes',
                            mensaje_esperar:mensaje,
                          });
  return resultados
}
//Guardar Pago
async function Guardar_Pago(dato, mensaje='Guardando datos...'){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User, Api, datos:JSON.stringify(dato)},
                            http_destino:'/api/procesarpago',
                            method:'POST',
                            destino:'archivos/imagenes',
                            mensaje_esperar:mensaje,
                          });
  return resultados
}
//Sincronizar los datos de base de datos
async function Sincronizar_uecla(dato){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User, Api, datos:JSON.stringify(dato)},
                            http_destino:'/api/colegio/sincronizar',
                            method:'POST',
                            destino:'archivos/imagenes'
                          });
  return resultados
}
//Actualizar referencia
async function Actualizar_Referencia(){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User, Api},
                            http_destino:'/api/colegio/actualizarreferencia',
                            method:'POST',
                            destino:'archivos/imagenes'
                          });
  return resultados
}
//Sincronizar los datos de base de datos
async function VerInscripcion_uecla(){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User, Api},
                            http_destino:'/api/colegio/verificarinscripcion',
                            method:'POST',
                            destino:'archivos/imagenes'
                          });
  return resultados
}
//Promueve estudiantes de 5 ano que esten solventes
async function Promover(Periodo){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User, Api, Periodo},
                            http_destino:'/api/colegio/promover',
                            method:'POST',
                            destino:'archivos/imagenes'
                          });
  return resultados
}
async function NominaDocente(Fecha, Periodo){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{User, Api, Fecha, Periodo},
                            http_destino:'/api/colegio/nominadocente',
                            method:'POST',
                            destino:'archivos/imagenes'
                          });
  return resultados
}
async function WhatsappEnviar(contactos, mensaje){
  const Api = `clientUECLA`;//Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{Api, contactos, mensaje},
                            http_destino:'/api/whatsappenviar',
                            method:'POST',
                          });
  return resultados
}
//SistemasCHS
//Guardar los la produccion del dia
async function Recibo_Venta(){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
    datos:{User, Api},
    http_destino:'/api/reciboventa',
    method:'GET',
    destino:'archivos/imagenes',
  });
  return resultados
}
async function Serial(dato){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
    datos:{User, Api, dato},
    http_destino:'/api/serial',
    method:'POST',
    destino:'archivos/imagenes',
  });
  return resultados
}
// async function Guardar_produccion(datos, mensaje='Guardando datos...'){
//   const Api = Ver_Valores().valores.app;
//   const resultados= await Enviar({
//                             datos:{User, Api, datos:JSON.stringify(datos)},
//                             http_destino:'/api/guardarproduccion',
//                             method:'POST',
//                             destino:'archivos/imagenes',
//                             mensaje_esperar:mensaje,
//                           });
//   return resultados
// }
// async function Ingresar(datos, tabla_inv, tabla_ing, id, egresar ){
//   const Api = Ver_Valores().valores.app;
//   const resultados= await Enviar({
//                             datos:{User, Api, datos:JSON.stringify(datos), tabla_inv, tabla_ing, id, egresar},
//                             http_destino:'/api/ingresar',
//                             method:'POST',
//                             destino:'archivos/imagenes'
//                           });
//   return resultados
// }
// async function Ingresar_material(datos, mensaje='Guardando datos...'){
//   const Api = Ver_Valores().valores.app;
//   const resultados= await Enviar({
//                             datos:{User, Api, datos:JSON.stringify(datos)},
//                             http_destino:'/api/ingresarmaterial',
//                             method:'POST',
//                             destino:'archivos/imagenes',
//                             mensaje_esperar:mensaje,
//                           });
//   return resultados
// }
// async function Ingresar_empaque(datos, mensaje='Guardando datos...'){
//   const Api = Ver_Valores().valores.app;
//   const resultados= await Enviar({
//                             datos:{User, Api, datos:JSON.stringify(datos)},
//                             http_destino:'/api/ingresarempaque',
//                             method:'POST',
//                             destino:'archivos/imagenes',
//                             mensaje_esperar:mensaje,
//                           });
//   return resultados
// }
// async function Ingreso_Egreso(datos, mensaje='Guardando datos...'){
//   const Api = Ver_Valores().valores.app;
//   const resultados= await Enviar({
//                             datos:{User, Api, datos:JSON.stringify(datos)},
//                             http_destino:'/api/ingresoegreso',
//                             method:'POST',
//                             destino:'archivos/imagenes',
//                             mensaje_esperar:mensaje,
//                           });
//   return resultados
// }
// async function Egreso_venta(datos){
//   const Api = Ver_Valores().valores.app;
//   const resultados= await Enviar({
//                             datos:{User, Api, datos:JSON.stringify(datos)},
//                             http_destino:'/api/egresoventa',
//                             method:'POST',
//                             destino:'archivos/imagenes'
//                           });
//   return resultados
// }
// async function Ventas(datos){
//   //datos.estado='pendiente', por cobrar
//   const Api = Ver_Valores().valores.app;
//   const resultados= await Enviar({
//                             datos:{User, Api, datos:JSON.stringify(datos)},
//                             http_destino:'/api/ventas',
//                             method:'POST',
//                             destino:'archivos/imagenes'
//                           });
//   return resultados
// }

//Leer Horario
// async function MisDatos(user, api, mensaje='Guardando datos...'){
//   const Api = Ver_Valores().valores.app;
//   const resultados= await Enviar({
//                             datos:{user, api:Api},
//                             http_destino:'/api/unefa/misdatos',
//                             method:'POST',
//                             destino:'archivos/imagenes',
//                             mensaje_esperar:mensaje,
//                           });
//   return resultados
// }
async function LeerHorario(dato, user, api, mensaje='Guardando datos...'){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{user, api:Api, datos:JSON.stringify(dato)},
                            http_destino:'/api/colegio/leerhorario',
                            method:'POST',
                            destino:'archivos/imagenes',
                            mensaje_esperar:mensaje,
                          });
  return resultados
}
async function GuardarHorario(dato, user, api, mensaje='Guardando datos...'){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{user, api:Api, datos:JSON.stringify(dato)},
                            http_destino:'/api/colegio/guardarhorario',
                            method:'POST',
                            destino:'archivos/imagenes',
                            mensaje_esperar:mensaje,
                          });
  return resultados
}
async function DisponibilidadHorario(dato, user, api, mensaje='Guardando datos...'){
  const Api = Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{user, api:Api, datos:JSON.stringify(dato)},
                            http_destino:'/api/colegio/disponibilidadhorario',
                            method:'POST',
                            destino:'archivos/imagenes',
                            mensaje_esperar:mensaje,
                          });
  return resultados
}
//Whatsapp
async function WhatsappQR(){
  const Api = `whatsappqr-uecla`;//Ver_Valores().valores.app;
  const resultados= await Enviar({
                            datos:{Api},
                            http_destino:'/api/whatsappqr',
                            method:'POST',
                          });
  return resultados
}

async function Enviar(props){
  // console.log('Enviar ====>',props);
  //Datos de props necesarios
  //datos: valores que desea Enviar
  //http_destino: destino del envio '/api' o 'http://www.ejemplo.com/api'
  // tipo: solo si es Archivo, de lo contrario se deja en blanco
  // method: metodo de envio POST, GET, DELETE, PUT
  const Lista_Local_web=['/api/getallc','/api/getall','/api/colegio/recibo', '/api/colegio/mensualidades', '/api/colegio/resumen','/api/colegio/solvencias'];
  let {datos, http_destino, destino, tipo, method, files, acciones}= props;
  http_destino = Ver_Valores().valores.http+ http_destino;
  // console.log('Enviar>>>>>>>', http_destino);
  //'/api/login' verificar si tambien funciona local
  let Respuesta
  if (Ver_Valores().tipo==='Electron' 
      && [ '/api/ver_api','/api/sincronizar','/api/login','/api/valor_dolar', 
      '/api/whatsappqr','/api/database','/api/colegio/sincronizar'].indexOf(props.http_destino)===-1
    ){
      Respuesta = await Procesar(props);
      if ((Lista_Local_web.indexOf(props.http_destino)===-1)|| Ver_Valores().conectadoserver===false){
        return Respuesta
      }
  }
  const timeout=props.timeout ? props.timeout : 85000;
  const hash= await encriptado.Hash_texto(JSON.stringify(datos));
  datos= {...datos, hash};
  var data=datos;
  if (tipo && tipo==='Archivos'){
    data =  new FormData();

    await Object.keys(files).map(val=>{
      data.append(val,files[val]);
      return val
    })
    
    await Object.keys(datos).map(async value =>{
      if (['User','Api'].indexOf(value)!==-1){
        data.append(value, JSON.stringify(datos[value]));
      }else{
        data.append(value, datos[value]);
      }
      // console.log(value,data.get(value))
      return value;
    })
    
  }
  // console.log('destino',http_destino);
  let options = {
    url: http_destino,
    method: method ? method : 'POST',
    timeout: timeout,
    headers: {
      'Accept': 'application/json',
      'Content-type': tipo==='Archivos' ?
                      'multipart/form-data' :
                      'application/json;charset=UTF-8',
      'destino':destino
    },
    data,
    onUploadProgress: (progressEvent)=> {
      var progreso = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      // console.log(progreso);
      if(acciones) acciones(progreso)
      // this.setState({progreso});
    },
    onDownloadProgress: progressEvent => {
      // let percentCompleted = Math.round(
      //   (progressEvent.loaded * 100) / progressEvent.total
      // );
      if(acciones) acciones(progressEvent)//progressEvent)
    },

  };
  // console.log('enviar',options);
  return await axios(options)
    .then((res) => {
      
      if (res.data.Respuesta==='Error' && res.data.mensaje==="no autorizado"){
        Usuario('Eliminar')
        window.location.reload()
      }
      // this.setState({cargando:false, progreso:0})
      if (Ver_Valores().tipo==='Electron' && Lista_Local_web.indexOf(props.http_destino)!==-1){
        Respuesta = Actualizar_datos(Respuesta, res.data,  props.http_destino);
        return Respuesta
      }else{
        return res.data
      }
      
    })
    .catch(err => {
      console.log('Error en ',options);
      // this.setState({cargando:false, progreso:0})
      return {Respuesta:'Error_c', mensaje:'Error en conexión, intente nuevamente'}
    } );
}
